'use client';

import { usePathname } from 'next/navigation';
import { AppShell } from '@/components/AppShell';

/**
 * LayoutWrapper Component
 *
 * Conditionally applies AppShell based on the current route.
 * Full-screen routes (email editor, landing page editor) skip AppShell.
 */
export function LayoutWrapper({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();

  // Check if current path is a fullscreen route (editors and campaign wizard)
  // Campaign wizard has its own full layout, so skip AppShell
  const isFullscreen =
    (pathname?.startsWith('/emails/') && pathname?.includes('/edit')) ||
    pathname === '/emails/new' ||
    (pathname?.startsWith('/email-templates/') && pathname?.includes('/edit')) ||
    pathname === '/email-templates/new' ||
    (pathname?.startsWith('/landing-pages/') && pathname?.includes('/edit')) ||
    (pathname?.startsWith('/workflows/') && pathname?.includes('/edit')) ||
    pathname === '/workflows/new' ||
    (pathname?.startsWith('/campaigns/') && pathname?.includes('/edit')) ||
    pathname === '/campaigns/new' ||
    // Public booking widget — meant to be embedded in iframes on customer
    // sites. Must not render the admin shell (sidebar, search, user menu).
    pathname?.startsWith('/book/');

  // Also check for auth pages
  const isAuthPage = pathname === '/login' || pathname === '/register';

  // Skip AppShell for fullscreen and auth pages
  if (isFullscreen || isAuthPage) {
    return <>{children}</>;
  }

  // Wrap in AppShell for normal pages
  return <AppShell>{children}</AppShell>;
}
